import { Alert } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getUserDisplayName } from "../../../common/utils/userDisplayName";
import type { RootState } from "../../store";

type Props = {
  ticketId: string;
  status: string;
  resolution?: string | null;
};

export const RejectionBanner = ({
  ticketId: _ticketId,
  status,
  resolution,
}: Props) => {
  const latest = useSelector(
    (state: RootState) => state.ticket.ticketRejections?.[0] ?? null
  );

  // A rejected work order returns to In Progress and has no status of its own, so
  // the banner gates on the resolution verdict. It self-hides once the technician
  // re-submits for review (status leaves IN_PROGRESS).
  if (resolution !== "REJECTED" || status !== "IN_PROGRESS") return null;

  return (
    <Alert
      type="error"
      showIcon
      message="Work Order Rejected"
      description={
        latest?.message
          ? `${latest.message} — rejected by ${latest.sender ? getUserDisplayName(latest.sender) : "unknown"} on ${dayjs(latest.created_at).format("DD/MM/YYYY HH:mm")}`
          : "No rejection reason provided"
      }
    />
  );
};
